import React from 'react';

function InfoIcon(props) {
  const {
    color,
    ...otherProps
  } = props;

  const defaultColor = '#2EB0E3';

  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" className='info-icon' {...otherProps}>
        <g id="2513---CRM---Alerts" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="2513---CRM---Alerts---View" transform="translate(-832.000000, -29.000000)">
                <g id="Group" transform="translate(818.000000, 15.000000)">
                    <g id="Group-52" transform="translate(15.000000, 15.000000)">
                        <g id="Group-53">
                            <g id="Group-54">
                                <circle id="Oval-43-Copy-16" stroke={color || defaultColor} cx="8" cy="8" r="8"></circle>
                                <text id="i" fontFamily="Lato-Black, Lato" fontSize="11" fontWeight="700" fill={color || defaultColor}>
                                    <tspan x="6.4325" y="12">i</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}

export default InfoIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/InfoIcon.js